import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { RootState } from "../../../../models";
import { PrepaidState } from "../../../../models/state";

export const getPrepaidData = (state: RootState): PrepaidState => _get(state, "prepaid");

// @ts-expect-error: form should exist
export const getFormById = (state: RootState, id: string): Form => getPrepaidData(state)[id];

export const isOrderComplete = (state: RootState) => getPrepaidData(state).registration.isOrderComplete;

export const getPrepaidTextBlocks = (state: RootState) => getPrepaidData(state).refill.content || [];

export const refillPackages = (state: RootState) => getPrepaidData(state).refill.packages || {};

export const prepaidDisclaimers = (state: RootState) => getPrepaidData(state).refill.disclaimers || {};

export const selectedPhonenumber = (state: RootState) => getPrepaidData(state).refill.selectedPhonenumber || "";

export const prepaidRefillTotalUpfrontPrice = (state: RootState) => getPrepaidData(state).refill.totalUpfrontPrice || 0;

export const getFallBackUrl = (state: RootState) => getPrepaidData(state).refill.fallBackUrl || "";

export const selectedPackageNames = (state: RootState) => getPrepaidData(state).refill.selectedPackageNames || [];

export const isNumberVerified = (state: RootState) => getPrepaidData(state).refill.isPhoneNumberValid || false;

export const selectedPackageCodes = (state: RootState) => getPrepaidData(state).refill.selectedRefillOptionCodes || [];

export const isRefillSelected = (state: RootState) => !_isEmpty(selectedPackageCodes(state)) || false;

export const isOrderSubmitted = (state: RootState) => getPrepaidData(state).refill.isSubmitted || false;

export const getRefillOrderRef = (state: RootState) => getPrepaidData(state).refill.orderRef || "";
